import {
  GlobalWorkerOptions,
  getDocument,
} from "pdfjs-dist/legacy/build/pdf.js";
import pdfWorker from "pdfjs-dist/build/pdf.worker?url";

GlobalWorkerOptions.workerSrc = pdfWorker;

export type PdfPasswordResult =
  | "not_required"
  | "required"
  | "validated"
  | "invalid"
  | "error";

export const checkPdfPassword = async (
  file: File,
  password = ""
): Promise<PdfPasswordResult> => {
  let loadingTask: ReturnType<typeof getDocument> | null = null;
  try {
    const data = await file.arrayBuffer();
    loadingTask = getDocument({ data, password });
    const document = await loadingTask.promise;
    await document.destroy();
    return password ? "validated" : "not_required";
  } catch (error: any) {
    try {
      await loadingTask?.destroy();
    } catch (_destroyError) {
      /* empty */
    }
    if (error?.name === "PasswordException") {
      return password ? "invalid" : "required";
    }
    return "error";
  }
};
